module.exports = __webpack_public_path__ + "static/img/6.d1bf33f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/7/1/zh/6.png
// module id = TMlQ
// module chunks = 0